import { render, staticRenderFns } from "./SantaSleighControl.vue?vue&type=template&id=af8bd6d0&scoped=true&"
import script from "./SantaSleighControl.js?vue&type=script&lang=js&"
export * from "./SantaSleighControl.js?vue&type=script&lang=js&"
import style0 from "./SantaSleighControl.css?vue&type=style&index=0&id=af8bd6d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8bd6d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VSlider})
